export const ConvertPreflight = {
  "Title": "Preflight",
  "Continue": "Continue",
  "Back": "Back",
  "ConvertTo": "Convert To ",
  "Profiles": {
    "Title": "Profiles",
    "LibType": {
      "Opt1": "Foxit",
      "Opt2": "PDF Standards",
      "Opt3": "Prepress, Color and Transparency"
    },
    "OperateType": {
      "Profiles": "Select Profiles",
      "SingleChecks": "Select single checks",
      "SingleFixups": "Select single fixups",
      "Filters": {
        "ShowAll": "Show all",
        "Favorites": "Favorites",
        "MostRecentlyUsed": "Most recently used",
        "MostFrequentlyUsed": "Most frequently used"
      },
      "SearchAllLibraries": "Search all libraries",
      "Find": "Find"
    },
    "DisplayAnalysis": "Display Analysis Result When you Analyze and fix",
    "Limited": "Preflight only page",
    "LimitedSplitter": "to",
    "UnacceptableCharacter": "Unacceptable character",
    "OutOfRange": "The number of pages that you entered is wrong",
    "Analyze": "Analyze",
    "Fix": "Fix",
    "AnalyzeAndFix": "Analyze and fix"
  },
  "Results": {
    "Title": "Results",
    "FileNameDivider": "Pages from",
    "Overview": "Overview",
    "Information": "Preflight information",
    "Date": "Date",
    "UserName": "User Name",
    "ComputerName": "Computer name",
    "OperatingSystem": "Operating system",
    "Duration": "Duration",
    "DocumentDetails": "Document details",
    "DocumentInfo": "Document information",
    "TextProperties": "Text properties",
    "FileName": "File name:",
    "VersionNumber": "PDF version number:",
    "FileSize": "File size (byte):",
    "Producer": "Producer:",
    "Created": "Created:",
    "Modified": "Modified:",
    "Trapping": "Trapping:",
    "Plates": "Plates:",
    "PostScriptName": "PostScript name:",
    "Encoding": "Encoding:",
    "Embedded": "Embedded:",
    "CurrentFontSize": "Current font size:",
    "True": "True",
    "False": "False",
    "Type": "Type",
    "Font": "font",
    "is": "is",
    "not": "not",
    "embedded": "embedded",
    "Page": "Page",
    "Pt": "pt",
    "PageDetails": "Page details",
    "MediaBox": "MediaBox",
    "CropBox": "CropBox",
    "TrimBox": "TrimBox",
    "BleedBox": "BleedBox",
    "AnnotsPresents": "Annotations and form fields",
    "AnnotsNotPresents": "Annotations: Not present",
    "LocationOfAnnots": "Location of the annotations (pt):",
    "LastModified": "Last Modified:",
    "PopUpWindowText": "Pop-up window text:",
    "TextAnnots": "Text Annotation",
    "CircleAnnots": "Circle Annotation",
    "SquigglyUnderlineAnnots": "Squiggly-underline Annotation",
    "PopupAnnots": "Pop-up Annotation",
    "ScreenAnnots": "Screen Annotation",
    "LinkAnnots": "Link Annotation",
    "PolygonAnnots": "Polygon Annotation",
    "StrikeoutAnnots": "Strikeout Annotation",
    "FileAttachmentAnnots": "File attachment Annotation",
    "PrinterMarkAnnots": "Printer's mark Annotation",
    "FreeTextAnnots": "Free text Annotation",
    "PolyLineAnnots": "Polyline Annotation",
    "RubberStampAnnots": "Polygon Annotation",
    "SoundAnnots": "Sound Annotation",
    "TrapNetworkAnnots": "Trap network Annotation",
    "LineAnnots": "Line Annotation",
    "HighlightAnnots": "Highlight Annotation",
    "CaretAnnots": "Caret Annotation",
    "MovieAnnots": "Movie Annotation",
    "WatermarkAnnots": "Watermark Annotation",
    "SquareAnnots": "Square Annotation",
    "UnderlineAnnots": "Underline Annotation",
    "InkAnnots": "Ink Annotation",
    "WidgetAnnots": "Widget Annotation",
    "3DAnnots": "3D Annotation",
    "PageRotation": "Page rotation",
    "PageRotationUnit": "degree counterclockwise",
    "OutputIntents": "Output Intents",
    "OutputCondition": "Output condition",
    "OutputConditionIdentifier": "Output condition identifier",
    "RegistryName": "Registry name",
    "Info": "Info",
    "ICCProfile": "ICC output profile",
    "ProfileVersionNumber": "Profile version number",
    "ColorManagementModule": "Color Management Module (CMM) type",
    "DeviceClassSignature": "Profile/Device class signature",
    "ColorspaceOfData": "Color space of data",
    "ProfileConnectionSpace": "Profile Connection Space (PCS)",
    "MagicNumber": "Magic number",
    "PrimaryPlatform": "Primary Platform",
    "DeviceManufacturer": "Device manufacturer",
    "DeviceModel": "Device model",
    "ProfileCreator": "Profile creator",
    "CreationDate": "Creation Date",
    "DefaultRenderingIntent": "Default rendering intent",
    "RelativeColorimetric": "Relative Colorimetric",
    "Saturation": "Saturation",
    "AbsoluteColorimetric": "Absolute Colorimetric",
    "Perceptual": "Perceptual",
    "Copyright": "Copyright information",
    "ProfileDescription": "Profile description",
    "None": "none"
  },
  "Standards": {
    "Title": "Standards",
    "SubTitle": "Create Standard compliant PDF",
    "Description1": "The PDF/A standard defines provisions for long term archiving of electronic documents in the PDF format. All content in a PDF/A file must be contained in such a way that viewing or printing of the file can be achieved reliably over a long period of time.",
    "Description10": "The PDF/A standard is available in three parts, where each part defines two or three conformance levels. It is recommended to choose the part and conformance level that matches the PDF document to be archived. Where digital signatures are required it is important to ensure conformance with the PDF/A standard before signing the PDF.",
    "Description11": "PDF/A-1a is suitable for archiving PDF 1.3 or PDF 1.4 files whose content structure is accessible through structure tags.",
    "ConversionProfile11": "Create PDF/A-1a according to the following PDF/A-1a conversion profile:",
    "ConversionProfile11Option1": "Convert to PDF/A-1a",
    "ConversionProfile11Description1": "Converts the current document to PDF/A-1a.",
    "Description12": "PDF/A-1b is suitable for archiving PDF 1.3 or PDF 1.4 files whose content structure is not accessible.",
    "ConversionProfile12": "Create PDF/A-1b according to the following PDF/A-1b conversion profile:",
    "ConversionProfile12Option1": "Convert to PDF/A-1b (without fallback conversion)",
    "ConversionProfile12Description1": "Converts the current document to PDF/A-1b without using any of the fallback options, which are normally applied when regular conversion fails.",
    "ConversionProfile12Option2": "Convert to PDF/A-1b",
    "ConversionProfile12Description2": "Converts the current document to PDF/A-1b.",
    "Description13": "PDF/A-2a is suitable for archiving PDF files up to version 1.7 whose content structure is accessible through structure tags.",
    "ConversionProfile13": "Create PDF/A-2a according to the following PDF/A-2a conversion profile:",
    "ConversionProfile13Option1": "Convert to PDF/A-2a",
    "ConversionProfile13Description1": "Converts the current document to PDF/A-2a. Layers, transparency and embedded files are preserved.",
    "Description14": "PDF/A-2b is suitable for archiving PDF files up to version 1.7 whose content structure is not accessible and whose text cannot be mapped to Unicode.",
    "ConversionProfile14": "Create PDF/A-2b according to the following PDF/A-2b conversion profile:",
    "ConversionProfile14Option1": "Convert to PDF/A-2b (without fallback conversion)",
    "ConversionProfile14Description1": "Converts the current document to PDF/A-2b without using any of the fallback options, which are normally applied when regular conversion fails.",
    "ConversionProfile14Option2": "Convert to PDF/A-2b",
    "ConversionProfile14Description2": "Converts the current document to PDF/A-2b. Layers, transparency and embedded files are preserved.",
    "Description15": "PDF/A-2u is suitable for archiving PDF files up to version 1.7 whose content structure is not accessible but whose text can be mapped to Unicode.",
    "ConversionProfile15": "Create PDF/A-2u according to the following PDF/A-2u conversion profile:",
    "ConversionProfile15Option1": "Convert to PDF/A-2u",
    "ConversionProfile15Description1": "Converts the current document to PDF/A-2u. Layers, transparency and embedded files are preserved.",
    "Description16": "PDF/A-3a is similar to PDF/A-2a but allows embedding of non-PDF/A files.",
    "ConversionProfile16": "Create PDF/A-3a according to the following PDF/A-3a conversion profile:",
    "ConversionProfile16Option1": "Convert to PDF/A-3a",
    "ConversionProfile16Description1": "Converts the current document to PDF/A-3a. Layers, transparency and embedded files are preserved.",
    "Description17": "PDF/A-3b is similar to PDF/A-2b but allows embedding of non-PDF/A files.",
    "ConversionProfile17": "Create PDF/A-3b according to the following PDF/A-3b conversion profile:",
    "ConversionProfile17Option1": "Convert to PDF/A-3b (without fallback conversion)",
    "ConversionProfile17Description1": "Converts the current document to PDF/A-3b without using any of the fallback options, which are normally applied when regular conversion fails.",
    "ConversionProfile17Option2": "Convert to PDF/A-3b",
    "ConversionProfile17Description2": "Converts the current document to PDF/A-3b. Layers, transparency and embedded files are preserved.",
    "Description18": "PDF/A-3u is similar to PDF/A-2u but allows embedding of non-PDF/A files.",
    "ConversionProfile18": "Create PDF/A-3u according to the following PDF/A-3u conversion profile:",
    "ConversionProfile18Option1": "Convert to PDF/A-3u",
    "ConversionProfile18Description1": "Converts the current document to PDF/A-3u. Layers, transparency and embedded files are preserved.",
    "Description2": "The PDF/E standard defines provisions for the use and exchange of engineering documents in the PDF format. It allows for the inclusion of dynamic content, like 3D models as well as a wide range of annotations, and at the same time requires the presence of all content and resources in the PDF file to guarantee reliable viewing and printing.",
    "Description20": "The PDF/E-1 standards enable the reliable exchange and use of documents like engineering drawings, CAD files and similar documents.",
    "Description21": "The PDF/E-1 requires that all page content and resources necessary for displaying or printing the document are included in the PDF file. A PDF/E file may be password protected and also supports the use of digital signatures.",
    "ConversionProfile21": "Create PDF/E-1 according to the following PDF/E-1 conversion profile:",
    "ConversionProfile21Option1": "Convert to PDF/E-1",
    "ConversionProfile21Description1": "Converts the current document to PDF/E-1",
    "Description3": "The PDF/X standard defines provisions for reliable PDF exchange in the graphic arts industry. PDF/X files must contain all page content and resources for predictable viewing and output.",
    "Description30": "The PDF/X standard consists of several parts, where each part defines specific requirements. For all PDF/X versions, the intended printing condition must be indicated through an Output Intent.",
    "Description31": "PDF/X-1a requires that all page content and resources are embedded. Transparency and layers are prohibited. In addition, only CMYK and spot colors are allowed.",
    "ConversionProfile31": "Create PDF/X-1a according to the following PDF/X-1a conversion profile:",
    "ConversionProfile31Option1": "Convert to PDF/X-1a (Coated GRACol 2006)",
    "ConversionProfile31Description1": "Converts the current document to PDF/X-1a for Coated GRACoL 2006 as the intended printing condition. Converts calibrated colors and device dependent RGB to CMYK where necessary, while maintaining spot colors. Layers and transparency are flattened if present.",
    "ConversionProfile31Option2": "Convert to PDF/X-1a (ISO Coated v2 (ECI))",
    "ConversionProfile31Description2": "Converts the current document to PDF/X-1a for ISO Coated v2 (ECI) as the intended printing condition. Converts calibrated colors and device dependent RGB to CMYK where necessary, while maintaining spot colors. Layers and transparency are flattened if present.",
    "ConversionProfile31Option3": "Convert to PDF/X-1a (Japan Color 2001 Coated)",
    "ConversionProfile31Description3": "Converts the current document to PDF/X-1a for Japan Color 2001 Coated as the intended printing condition. Converts calibrated colors and device dependent RGB to CMYK where necessary, while maintaining spot colors. Layers and transparency are flattened if present.",
    "ConversionProfile31Option4": "Convert to PDF/X-1a (PSO Coated v3 (ECI))",
    "ConversionProfile31Description4": "Converts the current document to PDF/X-1a for PSO Coated v3 (ECI) as the intended printing condition. Converts calibrated colors and device dependent RGB to CMYK where necessary, while maintaining spot colors. Layers and transparency are flattened if present.",
    "Description32": "PDF/X-3 requires that all page content and resources are embedded. Transparency and layers are prohibited. In addition to CMYK and spot colors, ICC based colors and Lab are allowed.",
    "ConversionProfile32": "Create PDF/X-3 according to the following PDF/X-3 conversion profile:",
    "ConversionProfile32Option1": "Convert to PDF/X-3 (Coated GRACol 2006)",
    "ConversionProfile32Description1": "Converts the current document to PDF/X-3 for Coated GRACoL 2006 as the intended printing condition. Converts calibrated colors and device dependent RGB to CMYK where necessary, while maintaining spot colors. Layers and transparency are flattened if present.",
    "ConversionProfile32Option2": "Convert to PDF/X-3 (ISO Coated v2 (ECI))",
    "ConversionProfile32Description2": "Converts the current document to PDF/X-3 for ISO Coated v2 (ECI) as the intended printing condition. Converts calibrated colors and device dependent RGB to CMYK where necessary, while maintaining spot colors. Layers and transparency are flattened if present.",
    "ConversionProfile32Option3": "Convert to PDF/X-3 (Japan Color 2001 Coated)",
    "ConversionProfile32Description3": "Converts the current document to PDF/X-3 for Japan Color 2001 Coated as the intended printing condition. Converts calibrated colors and device dependent RGB to CMYK where necessary, while maintaining spot colors. Layers and transparency are flattened if present.",
    "ConversionProfile32Option4": "Convert to PDF/X-3 (PSO Coated v3 (ECI))",
    "ConversionProfile32Description4": "Converts the current document to PDF/X-3 for PSO Coated v3 (ECI) as the intended printing condition. Converts calibrated colors and device dependent RGB to CMYK where necessary, while maintaining spot colors. Layers and transparency are flattened if present.",
    "Description33": "PDF/X-4 requires that all page content and resources are embedded. Transparency and layers are allowed as well as CMYK, spot colors, ICC based colors and Lab.",
    "ConversionProfile33": "Create PDF/X-4 according to the following PDF/X-4 conversion profile:",
    "ConversionProfile33Option1": "Convert to PDF/X-4 (Coated GRACol 2006)",
    "ConversionProfile33Description1": "Converts the current document to PDF/X-4 for Coated GRACoL 2006 as the intended printing condition according to the PDF/X-4 standard. Transparency and layers are allowed.",
    "ConversionProfile33Option2": "Convert to PDF/X-4 (ISO Coated v2 (ECI))",
    "ConversionProfile33Description2": "Converts the current document to PDF/X-4 for ISO Coated v2 (ECI) as the intended printing condition according to the PDF/X-4 standard. Transparency and layers are allowed.",
    "ConversionProfile33Option3": "Convert to PDF/X-4 (Japan Color 2001 Coated)",
    "ConversionProfile33Description3": "Converts the current document to PDF/X-4 for Japan Color 2001 Coated as the intended printing condition according to the PDF/X-4 standard. Transparency and layers are allowed.",
    "ConversionProfile33Option4": "Convert to PDF/X-4 (PSO Coated v3 (ECI))",
    "ConversionProfile33Description4": "Converts the current document to PDF/X-4 for PSO Coated v3 (ECI) as the intended printing condition according to the PDF/X-4 standard. Transparency and layers are allowed.",
    "ConversionProfile33Option5": "Convert to PDF/X-4 and create language layer views (ISO Coated v2 (ECI))",
    "ConversionProfile33Description5": "Converts the current document to PDF/X-4 for ISO Coated v2 (ECI) as the intended printing condition according to the PDF/X-4 standard. Transparency and layers are allowed. The following layer views (OCCDs) are created: Layer name starts with \"EN\" or ends with \"_EN\" - English layer view Layer name starts with \"DE\"(\"GE\") or ends with \"_DE\"(\"_GE\") - German layer view Layer name starts with \"FR\" or ends with \"_FR\" - French layer view Layer name starts with \"IT\" or ends with \"_IT\" - Italian layer view Layer name starts with \"ES\" or ends with \"_ES\" - Spanish layer view",
    "Description34": "PDF/X-4p is a variant of PDF/X-4, where the destination profile in Output Intent, describing the intended printing condition, is not embedded, but instead referenced by means of a unique ID.",
    "ConversionProfile34": "Create PDF/X-4p according to the following PDF/X-4p conversion profile:",
    "Conditions": "For the following viewing or printing condition, it will override the profile:",
    "Fallback": "If regular conversion fails:",
    "Conversion": "Conversion Options:",
    "ConvertColor": "Convert device independent RGB or Lab color into destination color space",
    "DecalibrateColor": "Decalibrate device independent Gray or CMYK",
    "ConvertProblems": "Convert pages with problems into images",
    "ConvertAll": "Convert all pages into images",
    "ImageResolution": "Image resolution (ppi):"
  },
  "SaveAsSettings": {
    "Title": "Preflight: Convert to",
    "Alert": "The document has been saved, however, it could not be converted according to the selected standard profiles: Convert to {type}. Please use Standards Validation and Creation with the profile \"Convert to {type}\" in order to identify those properties of the document which prevent it from being compliant to this profile."
  }
}